import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = {
    timerTitle: formatMessage(messages.timerTitle),
    sectionTitle: formatMessage(messages.sectionTitle),
    onlyLabel: formatMessage(messages.onlyLabel),
    upgradeLabel: formatMessage(messages.upgradeLabel),
    andLabel: formatMessage(messages.andLabel),
    suggestedPackagesTitle: formatMessage(messages.suggestedPackagesTitle),
    suggestedAddOnsTitle: formatMessage(messages.suggestedAddOnsTitle),
    selectedOfferingsLabel: formatMessage(messages.selectedOfferingsLabel),
    confirmChangesLabel: formatMessage(messages.confirmChangesLabel),
    chargeNotification: formatMessage(messages.chargeNotification),
    appliedToLabel: formatMessage(messages.appliedToLabel),
    addLabel: formatMessage(messages.addLabel),
    addOnOfferingsLabel: formatMessage(messages.addOnOfferingsLabel),
    selectOfferingsError: formatMessage(messages.selectOfferingsError),
    summaryTitle: formatMessage(messages.summaryTitle),
    fromLabel: formatMessage(messages.fromLabel),
  };

  return { translations };
};

export default useTranslations;
